import { render, staticRenderFns } from "./TradeContent.vue?vue&type=template&id=3256fa7c&scoped=true&"
import script from "./TradeContent.vue?vue&type=script&lang=js&"
export * from "./TradeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256fa7c",
  null
  
)

export default component.exports